import React from "react";

export default function Footer() {
  return (
    <footer className="lp-footer" data-testid="lp-footer">
      <div className="lp-footer-inner">
        <div>
          <div className="lp-footer-brand">ILIK</div>
          <div className="lp-footer-tagline">4 Seasons of You<sup style={{fontSize: '0.5em'}}>®</sup></div>
          <div className="lp-footer-copy">ILIK B.V.</div>
          <div className="lp-footer-copy">KVK: 93135262</div>
          <div className="lp-footer-copy">Netherlands</div>
        </div>
        <div className="lp-footer-col">
          <h4>Privacy</h4>
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms">Terms of Service</a>
        </div>
        <div className="lp-footer-col">
          <h4>Contact</h4>
          <a href="mailto:support@ilikapp.com">support@ilikapp.com</a>
        </div>
      </div>
    </footer>
  );
}
